<template>
  <div class="basic_wrap">
    <bsHeader title="支付订单" />
    <div class="pay_page">
      <div class="method_card">
        <p class="amount_text">¥{{ formatPrice(payData.actual_money) }}</p>
        <div
          v-for="item in paymentMethods"
          :key="item.key"
          class="method_item"
          :class="[
            paymentType === item.key ? 'active' : '',
            item.disabled ? 'disabled' : ''
          ]"
          @click="selectPayment(item)"
        >
          <div class="method_left">
            <span class="method_icon" :class="item.key"></span>
            <span class="method_name">{{ item.name }}</span>
          </div>
          <div class="method_right">
            <span class="method_tip">
              {{ item.tip }}
              <template v-if="item.showBalance">{{ formatPrice(payData.user_money) }}</template>
            </span>
            <span class="radio">
              <span class="radio_dot"></span>
            </span>
          </div>
        </div>
      </div>
      <div class="bottom_action">
        <button class="submit_btn" :disabled="submitting" @click="submitOrder">
          {{ submitting ? '处理中...' : submitText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import bsHeader from "../../components/bsHeader.vue";

export default {
  name: "ItemPay",
  components: {
    bsHeader
  },
  data() {
    return {
      paymentType: "alipay",
      submitting: false,
      paymentMethods: [
        { key: "agency", name: "他人代付", tip: "可用余额:", showBalance: true },
        { key: "balance", name: "余额支付", tip: "可用余额:", showBalance: true, disabled: true },
        { key: "alipay", name: "支付宝支付", tip: "支付快捷更友好" }
      ],
      payData: {
        user_money: 0,
        actual_money: 0,
        item_num: 0,
        item_list: [],
        buyer_remark: "",
        address: null
      }
    };
  },
  computed: {
    submitText() {
      return this.paymentType === "agency" ? "找人帮我支付" : "立即支付";
    }
  },
  created() {
    this.$parent.footer("item", false);
  },
  mounted() {
    this.loadPayData();
  },
  methods: {
    formatPrice(value) {
      var num = parseFloat(value) || 0;
      return num.toFixed(2);
    },
    selectPayment(item) {
      if (item.disabled) {
        return;
      }
      this.paymentType = item.key;
    },
    loadPayData() {
      var payJson = localStorage.getItem("shop_pay_confirm");
      if (!payJson) {
        this.$toast("订单信息已失效");
        this.$router.replace("/cart");
        return;
      }
      try {
        this.payData = JSON.parse(payJson) || this.payData;
      } catch (error) {
        this.$toast("订单信息异常");
        this.$router.replace("/cart");
      }
    },
    submitOrder() {
      if (this.submitting) {
        return;
      }
      if (!this.payData.item_list.length) {
        this.$toast("暂无可支付商品");
        return;
      }
      if (this.paymentType === "alipay") {
        // 假装加载，模拟拉起支付宝过程，再提示失败
        this.submitting = true;
        setTimeout(() => {
          this.submitting = false;
          this.$toast("拉取支付宝失败");
        }, 1500);
        return;
      }
      if (this.paymentType === "agency") {
        this.$router.push("/agencyPay");
        return;
      }
      return;
    }
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  min-height: 100vh;
  background: #f2f2f2;
  padding-top: 44px;
  padding-bottom: 110px;
}

.pay_page {
  padding: 16px 12px 0;
}

.method_card {
  background: #ffffff;
  border-radius: 8px;
  padding: 22px 12px 0;
}

.amount_text {
  margin-bottom: 20px;
  text-align: center;
  font-size: 18px;
  line-height: 25px;
  font-weight: 700;
  color: #ff5a24;
}

.method_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 58px;
  border-bottom: 1px solid #f2f2f2;
  user-select: none;
}

.method_item:last-child {
  border-bottom: none;
}

.method_left,
.method_right {
  display: flex;
  align-items: center;
}

.method_icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.method_icon::before,
.method_icon::after {
  content: "";
  position: absolute;
}

.agency {
  background: #f8a126;
}

.agency::before {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffffff;
  top: 2px;
  left: 5px;
}

.agency::after {
  width: 8px;
  height: 5px;
  border: 2px solid #ffffff;
  border-top: none;
  border-radius: 0 0 8px 8px;
  left: 2px;
  bottom: 2px;
}

.balance {
  background: #f4bf74;
}

.balance::before {
  width: 8px;
  height: 5px;
  border: 2px solid #ffffff;
  border-top: none;
  left: 2px;
  top: 4px;
}

.balance::after {
  width: 10px;
  height: 2px;
  background: #ffffff;
  left: 3px;
  bottom: 3px;
}

.alipay {
  background: #1daaf1;
}

.alipay::before {
  width: 8px;
  height: 2px;
  background: #ffffff;
  left: 4px;
  top: 4px;
  transform: rotate(-25deg);
}

.alipay::after {
  width: 6px;
  height: 6px;
  border-left: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
  left: 4px;
  bottom: 3px;
  transform: skew(-10deg);
}

.method_name {
  margin-left: 10px;
  font-size: 14px;
  color: #333333;
}

.method_tip {
  font-size: 11px;
  color: #b7b7b7;
}

.radio {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #d7d7d7;
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.radio_dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: transparent;
}

.active .radio {
  border-color: #ff6a2a;
  background: #ff6a2a;
}

.active .radio_dot {
  background: #ffffff;
}

.disabled {
  opacity: 0.55;
}

.disabled .method_name,
.disabled .method_tip {
  color: #c5c5c5;
}

.bottom_action {
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  padding: 12px 14px 22px;
  background: linear-gradient(to top, #f2f2f2 68%, rgba(242, 242, 242, 0));
}

.submit_btn {
  width: 100%;
  height: 46px;
  border-radius: 23px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  color: #ffffff;
  background: linear-gradient(90deg, #ff6a2a 0%, #ff5526 100%);
}

.submit_btn[disabled] {
  background: #c9c9c9;
}
</style>
